import React from "react";
import Cookies from "js-cookie";
import { Link, Trans, useI18next } from "gatsby-plugin-react-i18next";
import { Col, Row } from "react-bootstrap";
import { appInsights, cookiesInitiallyEnabledAI } from "../../applicationinsights";
import { cookiesInitiallyEnabledGTag, updateConsent } from "../../googleanalytics";

const CookieConsent = () => {
    const { t } = useI18next();
    const [userHasChosen, setUserHasChosen] = React.useState(false);
    const onAccept = () => {
        Cookies.set("ai_enabled", "true", {
            expires: 365
        });
        appInsights.getCookieMgr().setEnabled(true);

        
        Cookies.set("gtag_enabled", "true", {
            expires: 365
        });
        updateConsent(true);

        setUserHasChosen(true);
    };
    const onReject = () => {
        Cookies.set("ai_enabled", "false", {
            expires: 365
        });
        appInsights.getCookieMgr().setEnabled(false);
        Cookies.remove("ai_session");
        Cookies.remove("ai_user");

        
        Cookies.set("gtag_enabled", "false", {
            expires: 365
        });
        updateConsent(false);

        setUserHasChosen(true);
    };

    if ((cookiesInitiallyEnabledGTag() !== undefined && cookiesInitiallyEnabledAI() !== undefined) || userHasChosen) {
        return null;
    }

    return (
        <div
            style={{
                position: "fixed",
                bottom: 0,
                left: "50%",
                transform: "translate(-50%, -25%)",
                background: "white",
                paddingTop: "1em",
                zIndex: 999,
                width: "80%"

            }}
            className="border mb-1 p-3"
        >
            <Row>
                <Col className="col-12 col-md-10">
                    <h3>{t('cookies:cookies')}</h3>
                    <div>
                        <Trans i18nKey="cookies:consentText">
                            We use some essential cookies to make this service work.

                            We’d also like to use analytics cookies so we can understand how you use the service and make improvements.
                        </Trans>
                        <br/>
                        <br/>
                        <Link to="/cookies">{t('cookies:viewCookiePolicy')}</Link>
                    </div>
                </Col>
                <Col className="col-12 col-md-2 mt-3 mt-md-0">
                    <Row>
                        <Col className="mt-md-3 col-6 col-md-12">
                            <button className="btn btn-primary" onClick={onAccept}>{t('accept')}</button>
                        </Col>
                        <Col className="mt-md-3 col-6 col-md-12">
                            <button className="btn btn-secondary" onClick={onReject}>{t('reject')}</button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div >
    );
};

export default CookieConsent;
